var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 800"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF612B",
    d: "M451.667 546.666l-95-93.333c-28.333-28.334-28.333-76.667 0-105s76.667-28.333 105 0l95 95-105 103.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8155A2",
    d: "M830 170L451.667 546.666l105 105L935 273.333c46.667-46.667 13.334-126.667-53.333-126.667-20 1.667-38.333 8.334-51.667 23.334z"
  })));
}
export default SvgCheck;